<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon @click="goToNotifications" v-bind="attrs" v-on="on">
        <v-badge :content="unreadCount" :value="unreadCount" color="red" overlap>
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <span>Upozornenia</span>
  </v-tooltip>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NotificationBell',
  data() {
    return {
      pollingInterval: null
    };
  },
  computed: {
    ...mapGetters('userNotifications', {
      unreadCount: 'getUnreadCount'
    }),
    ...mapGetters('auth', ['isAuthenticated'])
  },
  methods: {
    ...mapActions('userNotifications', ['fetchUnreadCount']),
    goToNotifications() {
      if (this.$route.path !== '/notifications') {
        this.$router.push('/notifications');
      }
    }
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
          }
          this.fetchUnreadCount();
          this.pollingInterval = setInterval(() => {
            this.fetchUnreadCount();
          }, 30000);
        } else {
          if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
          }
        }
      }
    }
  },
  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }
};
</script>
